import { TXGridTemplate } from "../../../types/common/templates.types";

export const X_GRID_COL_4: TXGridTemplate = {
  "Grille à 4 Colonnes": {
    template: [
      {
        name: "XGrid",
        props: {
          all: {
            columns: 4,
          },
        },
      },
    ],
  },
};
